// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3gTiC","header":"MessagesList_header__3FaBM","chat":"MessagesList_chat__kgJqO"};